import {integrationValidatorModule} from "./integrationValidatorModule";

export interface IntegrationValidatorUrls {
    "validator.dataSources": string
    "validator.interfaces": string
    "validator": string
}

export class IntegrationValidatorUrlsProvider {
    urls: IntegrationValidatorUrls

    setUrls(urls: IntegrationValidatorUrls) {
        this.urls = urls
    }

    $get() {
        return this.urls
    }
}


integrationValidatorModule.provider("integrationValidatorUrls", IntegrationValidatorUrlsProvider)